import { useState } from 'react'
import ReactGA from 'react-ga4'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faLocationDot } from '@fortawesome/free-solid-svg-icons'

export const Hero = () => {
    const [email, setEmail] = useState('')
    return (
        <div className='bg-main lg:-mt-[70px]'>
            <div className='lg:max-w-[1938px] mx-auto relative'>
                <img
                    className='absolute show top-4 left-4 lg:hidden max-w-[90px] md:max-w-[200px] mx-auto'
                    src={`${process.env.PUBLIC_URL}/images/nisxpaxwest.webp`}
                    alt='NIS x Pax West'
                />{' '}
                <div className='w-full h-full absolute top-[80vw] md:top-[86vw] left-1/2 -translate-x-1/2 lg:left-0 lg:-translate-x-0 lg:top-[12vw]'>
                    <div className='md:mx-0 w-full lg:w-[48vw] lg:max-w-[920px] px-4 lg:px-8 relative'>
                        <img
                            className='hidden lg:block max-w-[280px] mx-auto'
                            src={`${process.env.PUBLIC_URL}/images/nisxpaxwest.webp`}
                            alt='NIS x Pax West'
                        />
                        <div className=''>
                            <div className='relative text-center'>
                                <h1 className='herotext text-gradient font-black'>
                                    <span className='whitespace-nowrap'>NIS America</span>
                                </h1>
                                <h1 className='herotext text-gradient font-black'>is going to</h1>
                                <h1 className='herotext text-gradient font-black'>
                                    <span className='whitespace-nowrap'>PAX West 2024</span>
                                </h1>
                            </div>
                            <div className='bg-char w-full lg:w-4/5'>
                                <div className='text-orange  font-black herotext-sub '>
                                    <div className='flex flex-col'>
                                        <div className='flex flex-col md:flex-row justify-start items-center gap-4'>
                                            <p className='text-white bg-orange py-1 px-4 text-sm font-bold min-w-[140px] text-center w-full md:w-auto'>
                                                Date
                                            </p>{' '}
                                            <h2 className='text-center md:text-left'>
                                                August 30th - <span className='whitespace-nowrap'>September 2nd</span>
                                            </h2>
                                        </div>{' '}
                                        <div className='flex flex-col md:flex-row justify-start items-center gap-4 mt-4'>
                                            <p className='text-white bg-orange py-1  px-4 text-sm font-bold min-w-[140px] text-center w-full md:w-auto'>
                                                Location
                                            </p>{' '}
                                            <h2 className='text-center md:text-left'>Seattle, WA</h2>{' '}
                                        </div>{' '}
                                    </div>
                                </div>
                                <div className=' text-navy font-bold text-base lg:text-sm mt-8 mx-auto text-center w-full md:w-4/5 lg:w-full md:px-4'>
                                    <p className=''>
                                        Enjoy demos of our upcoming titles, participate in contests, attend our
                                        JRPG-themed panel, and shop our{' '}
                                        <span className='whitespace-nowrap'>exclusive merch</span>*!
                                    </p>{' '}
                                    <p className=''>*while supplies last</p>{' '}
                                </div>
                                <button
                                    onClick={() => {
                                        ReactGA.event({
                                            action: 'click',
                                            event: 'link',
                                            category: 'Products',
                                            label: `Buy Badge`,
                                        })
                                    }}
                                    className='flex justify-center my-8 mx-auto hover:brightness-125 duration-300 w-[70%]'
                                >
                                    <a
                                        target='_blank'
                                        rel='noreferrer'
                                        className=''
                                        href='https://west.paxsite.com/en-us/registration.html'
                                    >
                                        <img
                                            className=''
                                            src={`${process.env.PUBLIC_URL}/images/button-buybadge.webp`}
                                            alt='buy badge'
                                        />
                                    </a>
                                </button>
                            </div>
                        </div>
                    </div>{' '}
                </div>
            </div>
        </div>
    )
}
